module.exports = "/images/arrowWhite.svg?7bf7c91e577d7ecfb7c30238e174d243";